import State from 'slotworks/state-machine/states/state';
import gameState from 'slotworks/model/game-state';
import SpinRecord from 'slotworks/model/gameplay/records/spin-record';
import regulation from 'slotworks/integration/revolver/regulations/regulation';
import Components from 'slotworks/components/components';
import doSettingsModel from 'model/do-settings-model';
import BuyoutResult from 'integration/buyout-result';

export default class BuyoutBonus extends State {
    public onEnter() {
        this.newGame();
        doSettingsModel.isCurrentBonusBuyOut = true;
        this.complete();
    }
    private newGame() {
        const buyoutRecord = gameState.getCurrentGame().latestRecord() as SpinRecord;
        const results = buyoutRecord.getResultsOfType(BuyoutResult) as BuyoutResult[];
        
        gameState.newGame();
        regulation.interactionStart();
        Components.betBar.winnings.setWinnings(0, 0);

        gameState.getCurrentGame().isBuyout = true;
        gameState.getCurrentGame().totalBet = results[0].totalBetCash;

        Components.betBar.setBalance(gameState.getCurrentGame().startBalance);
        Components.betMenu.setBalance(gameState.getCurrentGame().startBalance);

        gameState.getCurrentGame().isRecovered = true;
        gameState.getCurrentGame().records.push(buyoutRecord);
    }
}



// WEBPACK FOOTER //
// ./src/states/buyout-bonus.ts